(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/shared/tracking.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/shared/tracking.js');
'use strict';

const findDiffs = svs.myProfile.react.shared.helpers.findDiffs;
const _svs$myProfile$consta = svs.myProfile.constants,
  backendName = _svs$myProfile$consta.backendName,
  checkboxNotification = _svs$myProfile$consta.checkboxNotification;
const APP_NOTIFICATION_NAME = 'Correction notification app';
const MARKETPLACE_NAME = 'share updates';
const PERSONALIZATION_NAMES = {
  personalizedContentSvs: 'relevant content',
  personalizedContentExternal: 'offers and ads (partners)'
};
const SYNDICATE_NAMES = {
  14: 'Added games',
  15: 'Canceled games',
  5: 'Payments',
  8: 'Canceled team',
  6: 'Deposits',
  26: 'Withdrawal',
  9: 'Invitation accepted',
  21: 'Member leaves team',
  25: 'Member sets to resting'
};
const TRACKING_NAMES = {
  [backendName.CORRECTION_MAIL_KENO]: 'Correction Keno',
  [backendName.CORRECTION_MAIL_VIKING_LOTTO]: 'Correction Vikinglotto',
  [backendName.CORRECTION_MAIL_EUROJACKPOT]: 'Correction Eurojackpot',
  [backendName.CORRECTION_MAIL_LOTTO]: 'Correction Lotto',
  [backendName.WIN_RESULTS]: 'Correction Mail',
  [backendName.RECURRING_WAGER_REMINDERS]: 'Reminder prolong',
  [backendName.ADVERTING_EMAIL]: 'Communication Mail',
  [backendName.ADVERTISING_SMS]: 'Communication SMS',
  [backendName.ADVERTISING_LETTER]: 'Communication Letter',
  [backendName.VEGAS_COMMUNICATION]: 'Communication Vegas',
  [backendName.ADVERTISING_APP_NOTIFICATION]: 'Communication Notification App',
  [backendName.MARKET_RESEARCH]: 'Help us be better'
};
const getSyndicateValue = syndicateList => {
  let syndicateChecked;
  syndicateList === null || syndicateList === void 0 || syndicateList.forEach(element => {
    if (element.transportType === 'mailNotification') {
      syndicateChecked = element.enabled;
    }
  });
  return syndicateChecked;
};
const trackEvent = (actionName, checked) => {
  if (typeof actionName !== 'undefined' && typeof checked !== 'undefined') {
    const track = {
      category: 'My Profile',
      action: actionName,
      opt_label: checked ? 'Yes' : 'No'
    };
    svs.components.analytics.trackEvent(track);
  } else {
    svs.myProfile.logger.error('Undefined tracking in my profile');
  }
};
const trackSyndicate = change => {
  var _change$value, _change$value2;
  const actionName = SYNDICATE_NAMES[change === null || change === void 0 || (_change$value = change.value) === null || _change$value === void 0 ? void 0 : _change$value.mailTypeId];
  const checked = getSyndicateValue(change === null || change === void 0 || (_change$value2 = change.value) === null || _change$value2 === void 0 ? void 0 : _change$value2.transports);
  trackEvent(actionName, checked);
};
const trackMarketplace = checked => {
  trackEvent(MARKETPLACE_NAME, checked);
};
const trackCheckbox = change => {
  const actionName = TRACKING_NAMES[change === null || change === void 0 ? void 0 : change.key];
  const checked = change === null || change === void 0 ? void 0 : change.value;
  trackEvent(actionName, checked);
};
const trackNotification = (checkboxName, change) => {
  const actionName = 'Correction Numbergames';
  let label;
  switch (checkboxName) {
    case checkboxNotification.TRACK_MAIL:
      if (change) {
        label = 'Yes';
      } else {
        label = 'No';
      }
      break;
    case checkboxNotification.TRACK_LINK:
      label = 'link';
      break;
    case checkboxNotification.TRACK_WIN:
      label = 'winning mail';
      break;
    default:
      svs.myProfile.logger.warn('Undefined list in trackListChanges');
      break;
  }
  const track = {
    category: 'My Profile',
    action: actionName,
    opt_label: label
  };
  svs.components.analytics.trackEvent(track);
};

const trackPersonlization = (key, value) => {
  const formatedKey = PERSONALIZATION_NAMES[key];
  trackEvent(formatedKey, value);
};

const trackAppNotification = change => {
  trackEvent(APP_NOTIFICATION_NAME, change);
};

const trackListChanges = (newList, oldList, settings) => {
  const listOfChanges = findDiffs(newList, oldList);
  listOfChanges.forEach(change => {
    switch (settings) {
      case 'syndicate':
        trackSyndicate(change);
        break;
      case 'communication':
        trackCheckbox(change);
        break;
      case 'notifications':
        trackCheckbox(change);
        break;
      default:
        svs.myProfile.logger.warn('Undefined list in trackListChanges');
        break;
    }
  });
};
svs.myProfile.react.shared.tracking = {
  trackListChanges,
  trackPersonlization,
  trackAppNotification,
  trackNotification,
  trackMarketplace
};

 })(window);